import { TTripDetails } from '../../core/trip-details';

export const createTripInitialState = (): TTripDetails => ({
  trip: {
    id: 0,
    startTime: new Date().toJSON(),
    finishTime: new Date().toJSON(),
    salesStartDelay: 0,
    salesStopDelay: 0,
    refundStopDelay: 0,
    wagonCount: 0,
    seatCount: 0,
    soldSeatCount: 0,
    seatTicketSupported: false,
    blocked: false,
    wagons: [],
    route: {
      id: 0,
      number: '',
      nameHy: '',
      nameEn: '',
      nameRu: '',
      stationFromId: 0,
      stationToId: 0,
    },
    trainType: {
      id: 0,
      nameHy: '',
      nameEn: '',
      nameRu: '',
    },
  },
  route: {
    id: 0,
    number: '',
    nameHy: '',
    nameEn: '',
    nameRu: '',
    stationFromId: 0,
    stationToId: 0,
  },
  routeStations: [],
  routeStationZones: [],
  seats: [],
  tariffs: [],
  tariffTypes: [],
  trainTypes: [],
  trainWagonTypes: [],
  tripHash: '',
  zones: [],
  discounts: [],
});
